let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2BPbN")).then(() => parcelRequire('40eED'));